import { FileboxOperationEnum } from '../../../platform/filebox/enums/filebox-operation.enum';
import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';

/**
 * File log DTO for records
 */
@CaslSubject(AppSubjectEnum.FILE_LOG)
export class FileLogRecordDto extends BaseDto {
	/**
	 * Audit log ID
	 */
	auditLogId!: number;

	/**
	 * User ID
	 */
	userId!: number;

	/**
	 * Operation to be performed on the file
	 */
	operation!: FileboxOperationEnum;

	/**
	 * Composite key describing the event and action that triggered the notification
	 */
	key!: string;

	/**
	 * File UUID
	 */
	fileUuid!: string;

	/**
	 * Unique token for the file synchronization process
	 */
	synchronizationToken!: string;

	/**
	 * The worker ID that reserved the file
	 */
	leasedBy?: string;

	/**
	 * Timestamp until when the file is reserved
	 */
	leasedUntil?: Date;

	/**
	 * Timestamp for when the file was synchronized
	 */
	synchronizedAt?: Date;

	/**
	 * Error message if the file failed to synchronize
	 */
	synchronizationError?: string;
}
